import React from 'react';
import { Link } from 'gatsby';
import { Mail, Phone, MapPin } from './icons';
import CrisisGuidance from './CrisisGuidance';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="panel text-on-panel pt-20 pb-12 rounded-t-[3rem] relative overflow-hidden mx-4">
      <div className="container mx-auto px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          <div className="col-span-1">
            <Link
              to="/"
              className="font-serif text-3xl text-on-panel/90 block mb-6 hover:text-on-panel/80 transition-colors"
            >
              Peace Love Wellness
            </Link>
            <p className="text-on-panel leading-relaxed font-normal">
              Peace Love Wellness Mental Health Counseling PLLC offers relational, trauma-informed online therapy for adults and couples across
              New York. Our clinicians support clients facing anxiety, trauma, burnout, relationship strain, life transitions, identity
              questions, and repeating patterns. We help clients find care that fits clinically, personally, practically, and relationally.
            </p>
            <h3 className="text-2xl text-on-panel/90 mt-10 mb-6">Contact</h3>
            <ul className="space-y-4 text-on-panel font-normal">
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 mt-1 flex-shrink-0" aria-hidden="true" />
                <a
                  href="mailto:contact@peacelovewellness.co"
                  className="hover:text-on-panel/90 transition-colors break-words"
                >
                  contact@peacelovewellness.co
                </a>
              </li>

              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 flex-shrink-0" aria-hidden="true" />
                <a href="tel:+12122216100" className="hover:text-on-panel/90 transition-colors">
                  +1-212-221-6100
                </a>
              </li>

              <li className="flex items-center gap-3">
                <MapPin className="w-5 h-5 flex-shrink-0" aria-hidden="true" />
                <span>Online across New York</span>
              </li>

              <li className="mt-4">
                <Link to="/get-started" className="hover:text-on-panel/90 transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-2xl text-on-panel/90 mb-6">Services</h3>
            <ul className="space-y-4 text-on-panel font-normal">
              <li>
                <Link to="/individual-therapy" className="hover:text-on-panel/90 transition-colors">
                  Individual Therapy
                </Link>
              </li>
              <li>
                <Link to="/couples-relationship-therapy" className="hover:text-on-panel/90 transition-colors">
                  Couples & Relationship Therapy
                </Link>
              </li>
              <li>
                <Link to="/online-therapy" className="hover:text-on-panel/90 transition-colors">
                  Online Therapy
                </Link>
              </li>
              <li>
                <Link to="/start-therapy-sooner" className="hover:text-on-panel/90 transition-colors">
                  Supervised Clinicians
                </Link>
              </li>
              <li>
                <Link to="/how-we-help" className="hover:text-on-panel/90 transition-colors">
                  How We Help
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-2xl text-on-panel/90 mb-6">Practice</h3>
            <ul className="space-y-4 text-on-panel font-normal">
              <li>
                <Link to="/our-approach" className="hover:text-on-panel/90 transition-colors">
                  Our Approach
                </Link>
              </li>
              <li>
                <Link to="/coaching-and-spiritual-counseling" className="hover:text-on-panel/90 transition-colors">
                  Coaching & Spiritual Counseling
                </Link>
              </li>
              <li>
                <Link to="/our-clinicians" className="hover:text-on-panel/90 transition-colors">
                  Find Your Therapist
                </Link>
              </li>
              <li>
                <Link to="/insurance-fees" className="hover:text-on-panel/90 transition-colors">
                  Insurance & Fees
                </Link>
              </li>
              <li>
                <Link to="/culturally-responsive-therapy" className="hover:text-on-panel/90 transition-colors">
                  Culturally Responsive Care
                </Link>
              </li>
              <li>
                <Link to="/lgbtqia-affirming-therapy" className="hover:text-on-panel/90 transition-colors">
                  LGBTQIA+ Affirming Therapy
                </Link>
              </li>
              <li>
                <Link to="/enm-poly-therapy" className="hover:text-on-panel/90 transition-colors">
                  ENM, Poly & Relationship Diversity
                </Link>
              </li>
              <li>
                <Link to="/neurodivergent-affirming-therapy-new-york" className="hover:text-on-panel/90 transition-colors">
                  Neurodivergent-Affirming Therapy
                </Link>
              </li>
              <li>
                <Link to="/gender-affirming-therapy-new-york" className="hover:text-on-panel/90 transition-colors">
                  Gender-Affirming Therapy
                </Link>
              </li>
              <li>
                <Link to="/spanish-speaking-therapy-new-york" className="hover:text-on-panel/90 transition-colors">
                  Therapy in Spanish (Español)
                </Link>
              </li>
              <li>
                <Link to="/bilingual-therapy-new-york" className="hover:text-on-panel/90 transition-colors">
                  Bilingual & Bicultural Therapy
                </Link>
              </li>
              <li>
                <Link to="/first-generation-therapy-new-york" className="hover:text-on-panel/90 transition-colors">
                  First-Generation Therapy
                </Link>
              </li>
              <li>
                <Link to="/religious-trauma-therapy-new-york" className="hover:text-on-panel/90 transition-colors">
                  Religious Trauma & Spirituality
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-on-panel/90 transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-on-panel/90 transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <CrisisGuidance className="mb-8" />

        <div className="border-t border-tint/10 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-on-panel/80">
          <p>&copy; {currentYear} Peace Love Wellness. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
